import {materialTagManagement, materialUpload} from "../../basic/path"
import RequestModel from "../../basic/requestConfig";
export default {
    getTagData(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                method: 'get',
                url: materialTagManagement.getTagData,
                data: query.data ? query.data : {},
                params: query.params ? query.params : {},
                
            }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    delTag(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialTagManagement.delTag,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers:{
                        'Content-Type':"application/json;charset=UTF-8"
                    }
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    updateTag(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialTagManagement.updateTag,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers:{
                        'Content-Type':"application/json;charset=UTF-8"
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    delTagLevel(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialTagManagement.delTagLevel,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers:{
                        'Content-Type':"application/json;charset=UTF-8"
                    }
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    addTagLevel(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialTagManagement.addTagLevel,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers:{
                        'Content-Type':"application/json;charset=UTF-8"
                    }
                }),
                request = requestModel.defaultConfig();
                vue.axios(request).then(function (result) {
                    resolve(result);
                })
        });
    },
    editTagLevel(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: materialTagManagement.editTagLevel,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers:{
                        'Content-Type':"application/json;charset=UTF-8"
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

}
